
import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

const ReportsService = {
  // CONSUMPTION WISE SALES REPORT
  getConsumptionWiseSales: async (filters = {}) => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.REPORTS.CONSUMPTION_WISE_SALES,
        { params: filters }
      );
      return response;
    } catch (error) {
      console.error('Failed to fetch Consumption-wise Sales report:', error);
      throw error;
    }
  },


// Payment Analysis Reports
  getPaymentAnalysis: async (filters = {}) => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.REPORTS.PAYMENT_ANALYSIS,
        { params: filters }
      );


      return response;

    } catch (error) {
      console.error('Failed to fetch Payment Analysis report:', error);
      throw error;
    }
  },

//Discount Analysis reports
   getDiscountAnalysis: async (filters = {}) => {
        try {
          const response = await apiClient.get(
            ENDPOINTS.REPORTS.DISCOUNT_ANALYSIS,
            { params: filters }
          );
          return response;
        } catch (error) {
          console.error('Failed to fetch Discount Analysis report:', error);
          throw error;
        }
      },


   getDiscountCodes: async () => {
       const response = await apiClient.get(
          ENDPOINTS.REPORTS.DISCOUNT_CODES
        );
        return response;
      },
      
// Customer Insights Report
  getAll: async (filters = {}) => {
    try {
        const response = await apiClient.get(
        ENDPOINTS.REPORTS.CUSTOMER_INSIGHTS,
        { params: filters }
      );
      return response;
    } catch (error) {
      console.error("Failed to fetch Customer Insights report:", error);
      throw error;
    }
  },

// NEW VS OLD CUSTOMER
  getCustomerRetentionDaily: async (filters = {}) => {
    try {
      const response = await apiClient.get(
        ENDPOINTS.REPORTS.CUSTOMER_RETENTION_DAILY,
        { params: filters }
      );
      return response;
    } catch (error) {
      console.error('Failed to fetch Customer Retention Daily report:', error);
      throw error;
    }
  },

//DAILY WISE SALES REPORT

getDailySales: async (filters = {}) => {
  const response = await apiClient.get(
    '/api/reports/daily-sales',
    { params: filters }
  );
  return response;
},


// ITEM WISE SALES REPORT

getItemWiseSales: async (filters = {}) => {
  try {
    return await apiClient.get(
      ENDPOINTS.REPORTS.ITEM_WISE_SALES,
      { params: filters }
    );
  } catch (error) {
    console.error('Failed to fetch Item-wise Sales report:', error);
    throw error;
  }
},

// CATEGORY WISE SALES REPORT

getCategorySales : async (filters = {}) => {
  try {
    const response = await apiClient.get(
      ENDPOINTS.REPORTS.CATEGORY_WISE_SALES,
      { params: filters }
    );
    return response;
  } catch (error) {
    console.error('Failed to fetch Category-wise Sales report:', error);
    throw error;
  }
},

// HOURLY WISE SALES REPORT

getHourlySales: async (filters = {}) => {
  try {
    const response = await apiClient.get(
      ENDPOINTS.REPORTS.HOURLY_SALES,
      { params: filters }
    );
    return response;
  } catch (error) {
    console.error('Failed to fetch Hourly Sales report:', error);
    throw error;
  }
},

// Revenue Summary reports

getRevenueSummary: async (filters = {}) => {
      try {
        const response = await apiClient.get(
          ENDPOINTS.REPORTS.REVENUE_SUMMARY,
          { params: filters }
        );

        return response;

      } catch (error) {
        console.error('Failed to fetch Revenue Summary report:', error);
        throw error;
      }
    },

     getWaiterPerformance: async (filters = {}) => {
         try {

           const params = {};

           Object.keys(filters).forEach(key => {
             const value = filters[key];

             if (
               value !== null &&
               value !== undefined &&
               value !== ''
             ) {
               params[key] = value;
             }
           });

           const response = await apiClient.get(
             ENDPOINTS.REPORTS.WAITER_PERFORMANCE,
             { params }
           );

           return response;

         } catch (error) {
           console.error('Failed to fetch Waiter Performance report:', error);
           throw error;
         }
       },


// TABLE UTILIZATION REPORT
getTableUtilization: async (filters = {}) => {
  try {
    const params = {};

    Object.keys(filters).forEach(key => {
      const value = filters[key];
      if (value !== null && value !== undefined && value !== '') {
        params[key] = value;
      }
    });

    const response = await apiClient.get(
      ENDPOINTS.REPORTS.TABLE_UTILIZATION,
      { params }
    );

    return response;
  } catch (error) {
    console.error('Failed to fetch Table Utilization report:', error);
    throw error;
  }
},

//KOT Timing Analysis Reports

    getKOTTimingAnalysis: async (filters = {}) => {
      try {
        const response = await apiClient.get(
          ENDPOINTS.REPORTS.KOT_TIMING_ANALYSIS,
          { params: filters }
        );

        return response;

      } catch (error) {
        console.error('Failed to fetch KOT Timing Analysis report:', error);
        throw error;
      }
    },

    // Stock Status Reports

    getStockStatusReport: async (filters = {}) => {
      try {
        const response = await apiClient.get(
          ENDPOINTS.REPORTS.STOCK_STATUS,
          { params: filters }
        );

        return response;

      } catch (error) {
        console.error('Failed to fetch Stock Status report:', error);
        throw error;
      }
    },

    // LOYALTY POINTS REPORT
getLoyaltyPoints: async (filters = {}) => {
  try {
    const params = {};

    Object.keys(filters).forEach(key => {
      const value = filters[key];
      if (value !== null && value !== undefined && value !== '') {
        params[key] = value;
      }
    });

    const response = await apiClient.get(
      ENDPOINTS.REPORTS.LOYALTY_POINTS,
      { params }
    );

    return response;
  } catch (error) {
    console.error('Failed to fetch Loyalty Points report:', error);
    throw error;
  }
},

// GST REPORT

getGSTReport: async (payload = {}) => {
  const response = await apiClient.post(ENDPOINTS.REPORTS.GST_REPORT, payload);
  return response;
},

// GST REPORT DOWNLOAD

getGSTReportDownload: async (payload = {}) => {
  const response = await apiClient.post(
    ENDPOINTS.REPORTS.GST_DOWNLOAD,
    payload,
    { responseType: 'blob' }
  );

  return response;
}

};

export default ReportsService;
